import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle, 
    FormControl, 
    InputLabel, 
    MenuItem, 
    Select 
} from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const AcceptTicketQueueModal = ({ modalOpen, onClose, ticketId, user }) => {
    const history = useHistory();
    const [selectedQueue, setSelectedQueue] = useState("");
    const [queues, setQueues] = useState([]);

    useEffect(() => {
        const fetchQueues = async () => {
            try {
                const { data } = await api.get("/queue");
                setQueues(data);
            } catch (err) {
                toastError(err);
            }
        };
        if (modalOpen) fetchQueues();
    }, [modalOpen]);

    useEffect(() => {
        if (!modalOpen) {
            setSelectedQueue("");
        }
    }, [modalOpen]);

    const handleExecute = async () => {
        if (!selectedQueue) return;
        try {
            await api.put(`/tickets/${ticketId}`, {
                status: "open",
                userId: user?.id,
                queueId: selectedQueue,
            });
            onClose();
            history.push(`/tickets/${ticketId}`);
        } catch (err) {
            toastError(err);
        }
    };

    return (
        <Dialog open={modalOpen} onClose={onClose} >
            <DialogTitle>Selecionar departamento responsável</DialogTitle>
            <DialogContent dividers>
                <FormControl fullWidth variant="outlined">
                    <InputLabel>Selecione uma opção</InputLabel>
                    <Select
                        value={selectedQueue}
                        onChange={(e) => setSelectedQueue(e.target.value)}
                        label="Selecione"
                    >
                        {queues.map((q) => (
                            <MenuItem key={q.id} value={q.id}>
                                {q.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancelar</Button>
                <Button 
                    onClick={handleExecute} 
                    color="primary" 
                    variant="contained"
                    disabled={!selectedQueue}
                >
                    Aceitar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AcceptTicketQueueModal;
